class ProductHeroTabs extends HTMLElement {
  constructor() {
    super();
    this.currentTab = null;
    this.currentProductIndex = 0;
    this.autoplayInterval = null;
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;
    this.infoContainer = null;
    this.dotsContainer = null;
    this.showDots = this.dataset.showDots === 'true';
    this.showArrowsDesktop = this.dataset.showArrowsDesktop === 'true';
    this.showArrowsMobile = this.dataset.showArrowsMobile === 'true';
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  init() {
    this.tabs = this.querySelectorAll('.hero-tab');
    this.products = this.querySelectorAll('.hero-product');
    this.infoContainer = this.querySelector('.hero-product-info-container');
    this.dotsContainer = this.querySelector('.hero-product-dots');
    this.navPrev = this.querySelector('.hero-nav-arrow--prev');
    this.navNext = this.querySelector('.hero-nav-arrow--next');
    this.navAreaPrev = this.querySelector('.hero-nav-area--prev');
    this.navAreaNext = this.querySelector('.hero-nav-area--next');
    
    // Ativar primeira aba
    if (this.tabs.length > 0) {
      this.currentTab = this.tabs[0].dataset.tab;
      this.switchTab(this.currentTab);
    }

    // Event listeners
    this.setupTabListeners();
    this.setupNavigationListeners();
    this.setupDotsListeners();
    this.setupButton3Listener();

    // Autoplay
    if (this.autoplayEnabled) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  setupNavigationListeners() {
    // Setas de navegação (Desktop)
    if (this.navPrev) {
      this.navPrev.addEventListener('click', () => {
        this.previousProduct();
        this.stopAutoplay();
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });
    }

    if (this.navNext) {
      this.navNext.addEventListener('click', () => {
        this.nextProduct();
        this.stopAutoplay();
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });
    }

    // Áreas clicáveis (Mobile)
    if (this.navAreaPrev) {
      this.navAreaPrev.addEventListener('click', () => {
        this.previousProduct();
        this.stopAutoplay();
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });
    }

    if (this.navAreaNext) {
      this.navAreaNext.addEventListener('click', () => {
        this.nextProduct();
        this.stopAutoplay();
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });
    }
  }



  setupTabListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabHandle = tab.dataset.tab;
        this.switchTab(tabHandle);
        this.stopAutoplay();
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      });
    });
  }

  setupButton3Listener() {
    // O listener do botão 3 é configurado dinamicamente no updateProductInfo
    // quando o produto muda, então não precisamos de um listener estático aqui
  }

  switchTab(tabHandle) {
    // Atualizar abas visuais
    this.tabs.forEach(tab => {
      tab.classList.toggle('active', tab.dataset.tab === tabHandle);
    });

    // Filtrar produtos da aba ativa
    const activeProducts = Array.from(this.products).filter(
      product => product.dataset.tab === tabHandle
    );

    // Esconder todos os produtos
    this.products.forEach(product => {
      product.classList.remove('active', 'prev', 'next');
    });

    // Mostrar primeiro produto da aba e laterais
    if (activeProducts.length > 0) {
      this.currentTab = tabHandle;
      this.currentProductIndex = 0;
      this.updateProductPositions(activeProducts);
      this.updateProductInfo(activeProducts[0]);
      this.updateDots(activeProducts);
    }
  }

  updateProductPositions(activeProducts) {
    const totalProducts = activeProducts.length;
    
    activeProducts.forEach((product, index) => {
      product.classList.remove('active', 'prev', 'next');
      
      if (index === this.currentProductIndex) {
        product.classList.add('active');
      } else if (index === this.currentProductIndex - 1 || 
                 (this.currentProductIndex === 0 && index === totalProducts - 1)) {
        product.classList.add('prev');
      } else if (index === this.currentProductIndex + 1 || 
                 (this.currentProductIndex === totalProducts - 1 && index === 0)) {
        product.classList.add('next');
      }
    });

    // Atualizar dots quando posições mudam
    this.updateDots(activeProducts);
  }

  updateProductInfo(product) {
    if (!this.infoContainer || !product) return;

    // Fade out
    this.infoContainer.classList.add('is-updating');

    // Aguardar fade out completar
    setTimeout(() => {
      // Atualizar conteúdo
      const title = product.dataset.title || '';
      const description = product.dataset.description || '';
      const price = parseInt(product.dataset.price) || 0;
      const comparePrice = parseInt(product.dataset.comparePrice) || 0;
      // Data attributes com hífen são convertidos para camelCase: data-link-1 -> dataset.link1
      // Mas também podemos acessar diretamente via getAttribute para garantir
      const link1 = product.dataset.link1 || product.getAttribute('data-link-1') || '#';
      const link2 = product.dataset.link2 || product.getAttribute('data-link-2') || '#';

      // Configurações de parcelamento
      const installments = parseInt(this.infoContainer.dataset.installments) || 6;
      const interest = parseFloat(this.infoContainer.dataset.interest) || 0;

      // Título
      const titleEl = this.infoContainer.querySelector('.hero-product-title');
      if (titleEl) titleEl.textContent = title;

      // Descrição
      const descEl = this.infoContainer.querySelector('.hero-product-description');
      if (descEl) descEl.textContent = description;

      // Preço
      const priceCurrentEl = this.infoContainer.querySelector('.price-current');
      const priceCompareEl = this.infoContainer.querySelector('.price-compare');
      
      if (priceCurrentEl && price > 0) {
        priceCurrentEl.textContent = this.formatMoney(price);
      }

      if (priceCompareEl && comparePrice > price && comparePrice > 0) {
        priceCompareEl.textContent = this.formatMoney(comparePrice);
        priceCompareEl.style.display = 'inline';
      } else if (priceCompareEl) {
        priceCompareEl.style.display = 'none';
      }

      // Parcelamento
      const installmentsEl = this.infoContainer.querySelector('.hero-product-installments');
      if (installmentsEl && price > 0 && installments > 1) {
        const installmentValue = this.calculateInstallment(price, installments, interest);
        const interestText = interest > 0 ? 'no cartão' : 'sem juros';
        installmentsEl.textContent = `ou até ${installments}x de ${this.formatMoney(installmentValue)} ${interestText}`;
      } else if (installmentsEl) {
        installmentsEl.textContent = '';
      }

      // Atualizar botões
      const btn1 = this.infoContainer.querySelector('.hero-btn-1');
      const btn2 = this.infoContainer.querySelector('.hero-btn-2');
      const btn3 = this.infoContainer.querySelector('.hero-btn-3');
      
      // Botão 3 (WhatsApp) - atualizar texto e configurar pop-up
      if (btn3) {
        const btn3Text = this.getAttribute('data-btn3-text') || 'Fale conosco no WhatsApp';
        // Pegar configurações do produto atual (do data attribute do produto)
        const btn3CustomLink = product.getAttribute('data-button-3-custom-link') || product.dataset.button3CustomLink || '';
        const btn3OpenNewTab = product.getAttribute('data-button-3-open-new-tab') === 'true' || product.dataset.button3OpenNewTab === 'true';
        
        // Só mostrar o botão se tiver link configurado
        if (btn3CustomLink && btn3CustomLink.trim() !== '') {
          btn3.style.display = '';
          btn3.textContent = btn3Text;
          
          // Remover listeners anteriores se existirem
          const newBtn3 = btn3.cloneNode(true);
          btn3.parentNode.replaceChild(newBtn3, btn3);
          
          // Adicionar listener para abrir pop-up
          newBtn3.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (window.openWhatsAppPopup) {
              window.openWhatsAppPopup({
                customLink: btn3CustomLink,
                openInNewTab: btn3OpenNewTab
              });
            }
            return false;
          }, true);
        } else {
          // Esconder o botão se não tiver link
          btn3.style.display = 'none';
        }
      }
      
      // Botão 1 - atualizar link e texto
      if (btn1) {
        // Garantir que o link seja uma string válida
        const finalLink1 = (link1 && link1 !== '#' && link1.trim() !== '') ? link1 : '';
        
        // Só mostrar o botão se tiver link configurado
        if (finalLink1 && finalLink1.trim() !== '') {
          btn1.style.display = '';
          btn1.href = finalLink1;
          btn1.textContent = this.getAttribute('data-btn1-text') || 'BOTÃO 1';
        } else {
          // Esconder o botão se não tiver link
          btn1.style.display = 'none';
        }
      }
      
      // Botão 2 - atualizar link e texto
      if (btn2) {
        // Garantir que o link seja uma string válida
        const finalLink2 = (link2 && link2 !== '#' && link2.trim() !== '') ? link2 : '';
        
        // Só mostrar o botão se tiver link configurado
        if (finalLink2 && finalLink2.trim() !== '') {
          btn2.style.display = '';
          btn2.href = finalLink2;
          btn2.textContent = this.getAttribute('data-btn2-text') || 'VER PRODUTO';
        } else {
          // Esconder o botão se não tiver link
          btn2.style.display = 'none';
        }
      }

      // Fade in
      setTimeout(() => {
        this.infoContainer.classList.remove('is-updating');
      }, 50);
    }, 300); // Tempo do fade out
  }

  calculateInstallment(price, installments, interestRate) {
    if (interestRate === 0) {
      return Math.ceil(price / installments);
    }
    
    // Cálculo com juros compostos
    const monthlyRate = interestRate / 100;
    const installmentValue = price * (monthlyRate * Math.pow(1 + monthlyRate, installments)) / (Math.pow(1 + monthlyRate, installments) - 1);
    return Math.ceil(installmentValue);
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount);
  }

  startAutoplay() {
    this.stopAutoplay();
    
    this.autoplayInterval = setInterval(() => {
      this.nextProduct();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  nextProduct() {
    // Pegar produtos da aba ativa
    const activeProducts = Array.from(this.products).filter(
      product => product.dataset.tab === this.currentTab
    );

    if (activeProducts.length === 0) return;

    // Avançar índice
    this.currentProductIndex = (this.currentProductIndex + 1) % activeProducts.length;

    // Atualizar posições
    this.updateProductPositions(activeProducts);
    
    // Atualizar info do produto
    this.updateProductInfo(activeProducts[this.currentProductIndex]);
  }

  updateDots(activeProducts) {
    if (!this.dotsContainer || !this.showDots) return;

    const totalProducts = activeProducts.length;
    
    // Limpar dots existentes
    this.dotsContainer.innerHTML = '';

    // Criar dots
    for (let i = 0; i < totalProducts; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hero-product-dot';
      dot.setAttribute('aria-label', `Ir para produto ${i + 1}`);
      if (i === this.currentProductIndex) {
        dot.classList.add('active');
      }
      
      dot.addEventListener('click', () => {
        this.goToProduct(i);
      });
      
      this.dotsContainer.appendChild(dot);
    }
  }

  goToProduct(index) {
    const activeProducts = Array.from(this.products).filter(
      product => product.dataset.tab === this.currentTab
    );

    if (activeProducts.length === 0 || index < 0 || index >= activeProducts.length) return;

    this.currentProductIndex = index;
    this.updateProductPositions(activeProducts);
    this.updateProductInfo(activeProducts[this.currentProductIndex]);
    this.stopAutoplay();
    if (this.autoplayEnabled) {
      this.startAutoplay();
    }
  }

  setupDotsListeners() {
    // Dots são criados dinamicamente, então os listeners são adicionados em updateDots
  }

  previousProduct() {
    // Pegar produtos da aba ativa
    const activeProducts = Array.from(this.products).filter(
      product => product.dataset.tab === this.currentTab
    );

    if (activeProducts.length === 0) return;

    // Voltar índice
    this.currentProductIndex = (this.currentProductIndex - 1 + activeProducts.length) % activeProducts.length;

    // Atualizar posições
    this.updateProductPositions(activeProducts);
    
    // Atualizar info do produto
    this.updateProductInfo(activeProducts[this.currentProductIndex]);
  }
}

customElements.define('product-hero-tabs', ProductHeroTabs);


